import React, { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../../../assets/logo-without-bg.png";
import { ThemeContext } from "../../../../utils/ThemeContext";
import { Avatar, CircularProgress, Divider, ListItemIcon } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import CheckIcon from "@mui/icons-material/Check";
import { useStores } from "../../use-stores";
import AlertsBell from "./alerts/AlertsBell";
import {
  useActiveWorkspace,
  switchWorkspace,
  WORKSPACES,
} from "../../../../utils/WorkspaceContext";

type AppBarProps = {
  handleMenuClick: () => void;
};

// const THEMES = [
//   {
//     key: "light",
//     label: "Light",
//     icon: <Brightness7Icon fontSize="small" />,
//     color: "#4338CA",
//   },
//   {
//     key: "dark",
//     label: "Dark",
//     icon: <Brightness4Icon fontSize="small" />,
//     color: "#90caf9",
//   },
//   {
//     key: "blue",
//     label: "Blue",
//     icon: <PaletteIcon fontSize="small" />,
//     color: "#2196F3",
//   },
//   {
//     key: "green",
//     label: "Green",
//     icon: <PaletteIcon fontSize="small" />,
//     color: "#388E3C",
//   },
// ];

function Navbar({ handleMenuClick }: AppBarProps) {
  // const [themeAnchorEl, setThemeAnchorEl] = React.useState<null | HTMLElement>(
  //   null,
  // );
  const [profileAnchorEl, setProfileAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [workspaceAnchorEl, setWorkspaceAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const { userStore } = useStores();
  const [loading, setLoading] = useState(false);
  const activeWorkspace = useActiveWorkspace();

  // const isThemeMenuOpen = Boolean(themeAnchorEl);
  const isProfileMenuOpen = Boolean(profileAnchorEl);
  const isWorkspaceMenuOpen = Boolean(workspaceAnchorEl);

  const themeContext = useContext(ThemeContext);
  if (!themeContext) return null;
  const { themeName } = themeContext;

  const isDark = themeName === "dark";

  // const handleThemeMenuOpen = (e: React.MouseEvent<HTMLElement>) =>
  //   setThemeAnchorEl(e.currentTarget);
  // const handleThemeMenuClose = () => setThemeAnchorEl(null);
  // const handleThemeChange = (theme: string) => {
  //   setThemeName(theme);
  //   handleThemeMenuClose();
  // };
  const handleProfileMenuOpen = (e: React.MouseEvent<HTMLElement>) =>
    setProfileAnchorEl(e.currentTarget);
  const handleProfileMenuClose = () => setProfileAnchorEl(null);

  const handleWorkspaceMenuOpen = (e: React.MouseEvent<HTMLElement>) =>
    setWorkspaceAnchorEl(e.currentTarget);
  const handleWorkspaceMenuClose = () => setWorkspaceAnchorEl(null);
  const activeWorkspaceLabel =
    WORKSPACES.find((w) => w.id === activeWorkspace)?.label ?? "";

  const handleLogOut = async () => {
    setLoading(true);
    try {
      await userStore.logOut();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const userInitial = userStore.user?.name?.charAt(0)?.toUpperCase() || "U";

  const navBg = isDark ? "#1E293B" : "#FFFFFF";
  const navBorder = isDark ? "1px solid #334155" : "1px solid #E2E8F0";
  const textColor = isDark ? "#F1F5F9" : "#0F172A";
  const subtleText = isDark ? "#94A3B8" : "#64748B";
  const iconHoverBg = isDark ? "rgba(255,255,255,0.08)" : "#F1F5F9";

  // const renderThemeMenu = (
  //   <Menu
  //     anchorEl={themeAnchorEl}
  //     open={isThemeMenuOpen}
  //     onClose={handleThemeMenuClose}
  //     anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     PaperProps={{
  //       elevation: 0,
  //       sx: {
  //         mt: 1,
  //         minWidth: 170,
  //         border: "1px solid #E2E8F0",
  //         borderRadius: "10px",
  //         overflow: "visible",
  //         boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  //         "& .MuiMenuItem-root": {
  //           borderRadius: "6px",
  //           mx: 0.5,
  //           my: 0.25,
  //           fontSize: 13,
  //           fontFamily: "Inter, sans-serif",
  //           fontWeight: 500,
  //         },
  //       },
  //     }}
  //   >
  //     <Typography
  //       sx={{
  //         px: 2,
  //         pt: 1,
  //         pb: 0.5,
  //         fontSize: 11,
  //         fontWeight: 600,
  //         color: "#94A3B8",
  //         letterSpacing: "0.06em",
  //         textTransform: "uppercase",
  //       }}
  //     >
  //       Appearance
  //     </Typography>
  //     {THEMES.map((t) => (
  //       <MenuItem
  //         key={t.key}
  //         onClick={() => handleThemeChange(t.key)}
  //         selected={themeName === t.key}
  //       >
  //         <ListItemIcon sx={{ color: t.color, minWidth: 32 }}>
  //           {t.icon}
  //         </ListItemIcon>
  //         {t.label}
  //         {themeName === t.key && (
  //           <CheckIcon sx={{ ml: "auto", fontSize: 14, color: "#4338CA" }} />
  //         )}
  //       </MenuItem>
  //     ))}
  //   </Menu>
  // );

  const renderWorkspaceMenu = (
    <Menu
      anchorEl={workspaceAnchorEl}
      open={isWorkspaceMenuOpen}
      onClose={handleWorkspaceMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{
        elevation: 0,
        sx: {
          mt: 1,
          minWidth: 220,
          border: "1px solid #E2E8F0",
          borderRadius: "10px",
          overflow: "visible",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          "& .MuiMenuItem-root": {
            borderRadius: "6px",
            mx: 0.5,
            my: 0.25,
            fontSize: 13,
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
          },
        },
      }}
    >
      <Typography
        sx={{
          px: 2,
          pt: 1,
          pb: 0.5,
          fontSize: 11,
          fontWeight: 600,
          color: "#94A3B8",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
        }}
      >
        Switch Workspace
      </Typography>
      {WORKSPACES.map((workspace) => (
        <MenuItem
          key={workspace.id}
          selected={workspace.id === activeWorkspace}
          onClick={() => {
            handleWorkspaceMenuClose();
            if (workspace.id !== activeWorkspace) {
              switchWorkspace(workspace.id);
            }
          }}
        >
          {workspace.label}
          {workspace.id === activeWorkspace && (
            <CheckIcon sx={{ ml: "auto", fontSize: 14, color: "#4338CA" }} />
          )}
        </MenuItem>
      ))}
    </Menu>
  );

  const renderProfileMenu = (
    <Menu
      anchorEl={profileAnchorEl}
      open={isProfileMenuOpen}
      onClose={handleProfileMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        elevation: 0,
        sx: {
          mt: 1,
          minWidth: 200,
          border: "1px solid #E2E8F0",
          borderRadius: "10px",
          overflow: "visible",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        },
      }}
    >
      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0F172A",
            fontFamily: "Inter, sans-serif",
          }}
        >
          {userStore.user?.name}
        </Typography>
        <Typography
          sx={{
            fontSize: 11,
            color: "#64748B",
            mt: 0.25,
            fontFamily: "Inter, sans-serif",
          }}
        >
          {userStore.user?.email || "Swageazy Team"}
        </Typography>
      </Box>
      <Divider sx={{ my: 0.5 }} />
      <MenuItem
        onClick={handleLogOut}
        disabled={loading}
        sx={{
          mx: 0.5,
          my: 0.25,
          borderRadius: "6px",
          fontSize: 13,
          fontFamily: "Inter, sans-serif",
          color: "#EF4444",
          "&:hover": { bgcolor: "#FEF2F2" },
        }}
      >
        <ListItemIcon sx={{ minWidth: 32 }}>
          {loading ? (
            <CircularProgress size={14} />
          ) : (
            <LogoutIcon fontSize="small" sx={{ color: "#EF4444" }} />
          )}
        </ListItemIcon>
        Sign out
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: navBg,
          borderBottom: navBorder,
          color: textColor,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            minHeight: "56px !important",
            px: { xs: 1.5, sm: 2.5 },
            gap: 1,
          }}
        >
          {/* Hamburger */}
          <IconButton
            size="medium"
            edge="start"
            aria-label="open drawer"
            onClick={handleMenuClick}
            sx={{
              color: subtleText,
              borderRadius: "8px",
              "&:hover": { bgcolor: iconHoverBg, color: textColor },
              mr: 0.5,
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>

          {/* Brand */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <img
                src={logo}
                alt="Swageazy"
                style={{ height: 32, width: "auto", objectFit: "contain" }}
              />
            </Box>
            <Box
              onClick={handleWorkspaceMenuOpen}
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                borderRadius: "8px",
                px: 0.75,
                py: 0.25,
                "&:hover": { bgcolor: iconHoverBg },
              }}
            >
              <Typography
                sx={{
                  fontSize: { sm: 16, md: 18 },
                  fontWeight: 700,
                  lineHeight: 1,
                  color: textColor,
                  fontFamily: "Inter, sans-serif",
                  letterSpacing: "-0.01em",
                }}
              >
                {activeWorkspaceLabel}
              </Typography>
              <KeyboardArrowDownIcon
                sx={{ fontSize: 16, color: subtleText }}
              />
            </Box>
          </Box>

          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Right actions */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {/* Alerts */}
            <AlertsBell
              iconColor={subtleText}
              iconHoverColor={textColor}
              iconHoverBg={iconHoverBg}
            />

            {/* Theme switcher */}
            {/* <Tooltip title="Change theme">
              <IconButton
                size="medium"
                onClick={handleThemeMenuOpen}
                sx={{
                  color: subtleText,
                  borderRadius: "8px",
                  "&:hover": { bgcolor: iconHoverBg, color: textColor },
                }}
              >
                <PaletteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {renderThemeMenu} */}

            {/* Divider — hidden on xs */}
            {/* <Box
              sx={{
                display: { xs: "none", sm: "block" },
                width: 1,
                height: 24,
                bgcolor: isDark ? "#334155" : "#E2E8F0",
                mx: 0.5,
              }}
            /> */}

            {/* User profile */}
            <Box
              onClick={handleProfileMenuOpen}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1,
                py: 0.5,
                borderRadius: "8px",
                cursor: "pointer",
                "&:hover": { bgcolor: iconHoverBg },
                transition: "background 0.15s",
              }}
            >
              <Avatar
                src={userStore.user?.image_url}
                alt={userStore.user?.name}
                sx={{
                  width: 30,
                  height: 30,
                  fontSize: 12,
                  fontWeight: 700,
                  bgcolor: "#4338CA",
                  color: "#fff",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {userInitial}
              </Avatar>
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: textColor,
                    lineHeight: 1,
                    fontFamily: "Inter, sans-serif",
                    maxWidth: 120,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {userStore.user?.name || "User"}
                </Typography>
              </Box>
              <KeyboardArrowDownIcon sx={{ fontSize: 16, color: subtleText }} />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      {renderWorkspaceMenu}
      {renderProfileMenu}
    </Box>
  );
}

export default React.memo(Navbar);
